import {ErrorPriority} from "../../enums/ErrorPriority";
import {BaseError} from "./BaseError";
import {NavigationVisitor} from "../navigation/NavigationVisitor";
import {Tenant} from "../tenant/Tenant";
import {TenantApplication} from "../tenant/TenantApplication";
import {ErrorLog} from "./ErrorLog";

export class Exception extends BaseError {
    private static DESCRIPTION_KEY = "error.name.exception";

    message: string;
    stackTrace?: string;

    constructor(id: string, tenant: Tenant, application: TenantApplication, mostRecentOccurred: Date | string, occurrenceCount: number,
                errorPriority: ErrorPriority, isSolved: boolean, message: string, stackTrace?: string, errorlogs?: ErrorLog[], solution?: string) {
        super(id, tenant, application, mostRecentOccurred, occurrenceCount, errorPriority, isSolved, errorlogs, solution);
        this.message = message;
        this.stackTrace = stackTrace;
    }

    public override accept(visitor: NavigationVisitor, openNewTab: boolean = false): void {
        visitor.visitException(this, openNewTab);
    }

    public override get descriptionKey(): string {
        return Exception.DESCRIPTION_KEY;
    }

    protected override getContentForSummary(): string {
        return this.stackTrace ?? this.message;
    }
}
